import { ActiveTabEnum, UserState } from "../types";

export const initialState: UserState = {
  loading: false,
  error: null,
  activities: {
    filters: {
      q: "",
      activityTypeIds: [],
      projectIds: []
    },
    data: [],
    meta: {
      page: 0,
      perPage: 0
    },
    loading: false
  },
  activeTab: ActiveTabEnum.Active,
  selectedMemberId: "",
  userStatus: null,
};
